import React from 'react'
import {useLocation, useParams} from 'react-router-dom'
import {EquipeForm} from './components/EquipeForm'
import {ModeleEquipe} from '../../../components/Models'

type LocationState = {
  data: ModeleEquipe | undefined | null
}

const EquipePage = () => {
  let {equipeId} = useParams()

  const location = useLocation()
  const state = location.state as LocationState

  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div className='card-header border-0'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>
              {equipeId === undefined ? 'Créer' : 'Modifier'} une équipe
            </h3>
          </div>
        </div>

        <div>
          <EquipeForm id={equipeId} data={state ? state.data : null} />
        </div>
      </div>
    </>
  )
}

export {EquipePage}
